namespace $.$$ {

	export class $shm_service_dashboard_head extends $.$shm_service_dashboard_head {

		mode_rows() {
			return [
				this.Task_mode_edit(),
				... this.view_visible() ? [ this.Task_mode_view() ] : [],
			] as readonly $mol_view[]
		}

	}

}
